import { gql } from "@apollo/client";

export const CONTACT_US = gql`
    mutation contactUs($name: String, $email: String, $reason: String, $details: String, $captchaToken: String) {
        contactUs(name: $name, email: $email, reason: $reason, details: $details, captchaToken: $captchaToken)
    }
`